import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Data, Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { DialogConfirmacaoComponent } from '@components/dialog-confirmacao/dialog-confirmacao.component';

import { ModeloVistoriaApiService } from '../../editar-modelo-vistoria/services/modelo-vistoria-api.service';
import { ModeloVistoriaListItem } from '../../editar-modelo-vistoria/models/modelo-vistoria-list-item';
import { MessageService } from '@services/message.service';
import { Permissao } from '@models/enums/permissao';

@Component({
  selector: 'app-listar-modelos-vistoria',
  standalone: false,
  templateUrl: './listar-modelos-vistoria.component.html',
  styleUrl: './listar-modelos-vistoria.component.scss'
})
export class ListarModelosVistoriaComponent implements OnInit {

  protected get permissaoEditarRoteiroVistoria() { return Permissao.EDITAR_ROTEIRO_VISTORIA; }

  modelos: ModeloVistoriaListItem[] = [];

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private modeloVistoriaApiService: ModeloVistoriaApiService,
    private messageService: MessageService,
    private dialog: MatDialog,
  ) { }

  ngOnInit(): void {
    this.route.data.subscribe((data: Data) => {
      this.modelos = data['modelos'] as ModeloVistoriaListItem[];
    });
  }

  public novoClick(): void {
    this.router.navigate(['/vistoria/modelos/novo']);
  }

  public editarClick(modelo: ModeloVistoriaListItem): void {
    this.router.navigate(['/vistoria/modelos', modelo.id, 'editar']);
  }

  public duplicarClick(modelo: ModeloVistoriaListItem): void {
    this.modeloVistoriaApiService.duplicar(modelo.id).subscribe(() => {
      this.messageService.showToastSuccess(`Modelo "${modelo.nome}" duplicado com sucesso`);
      this.recarregarLista();
    });
  }

  public removerClick(modelo: ModeloVistoriaListItem): void {
    const dialogRef = this.dialog.open(DialogConfirmacaoComponent, {
      width: '467px',
      panelClass: 'no-padding-dialog',
      disableClose: true,
    });
    dialogRef.componentInstance.titulo = 'Remover modelo';
    dialogRef.componentInstance.mensagem = `O modelo "${modelo.nome}" será removido. Vistorias já criadas a partir dele não são afetadas.`;
    dialogRef.componentInstance.textoBtnConfirmacao = 'Remover';
    dialogRef.componentInstance.btnBackgroundColor = '#F44336';
    dialogRef.componentInstance.acaoConfirmacao = () => this.remover(modelo);
  }

  private remover(modelo: ModeloVistoriaListItem): void {
    this.modeloVistoriaApiService.deletar(modelo.id).subscribe(() => {
      this.messageService.showToastSuccess('Modelo removido com sucesso');
      this.modelos = this.modelos.filter(m => m.id !== modelo.id);
    });
  }

  private recarregarLista(): void {
    this.modeloVistoriaApiService.listar().subscribe(modelos => this.modelos = modelos);
  }
}
